export default "__VITE_ASSET__DrBsiN58__"